<template>
  <div
      class="text-sm font-medium text-center text-gray-500 overflow-y-clip">
    <TsTabsCategorySelection
      :tabs="props.tabs"
      :active="active_tab_id"
      @tabClick="handleTabClick"
      append-class="mb-3"
    />

    <slot name='content'>
      <div v-if="active_tab_content">
        <Blocks
            :parent="props.builderBlock?.id"
            :path="`component.options.tabs.${active_tab_index}.content`"
            :blocks="active_tab_content"
        />
      </div>
    </slot>
  </div>
</template>

<script setup lang="ts">
import {ref, computed} from 'vue';
import {Blocks} from '@builder.io/sdk-vue';

type Props = {
  tabs?: any,
  builderBlock?: object,
  defaultActiveTab?: number,
  collapsible?: boolean,
  tabHeaderLayout?: string,
  activeTabStyle?: object,
  tabClass?:string,
}

const TsTabsCategorySelection = defineAsyncComponent(
    () => import('~/components/molecules/TsTabsCategorySelection.vue')
);

const emit=defineEmits(['active-slide']);

const props = withDefaults(defineProps<Props>(), {
  tabs: () => ([
    {id: '1', label: 'All', content: []},
    {id: '2', label: 'All - 2', content: []},
    {id: '3', label: 'All - 3', content: []}
  ])
});

const active_tab_id = ref(props.tabs?.[0]?.id);
const active_tab_index = ref(0);

function handleTabClick(tab, index) {
  active_tab_index.value = index;
  active_tab_id.value = tab.id;
}

// Compute the active tab's content directly
const active_tab_content = computed(() => {
  // Ensure tabs exist and have content
  return props.tabs && props.tabs.length > active_tab_index.value
      ? props.tabs[active_tab_index.value].content
      : undefined;
});


</script>

